import React from "react";
import { IMAGES } from "../../lib/content";

const TILES = [
  { id: "shingle-install", src: IMAGES.gallery[0], alt: "Residential brown shingle roof installation", span: "col-span-6 row-span-2" },
  { id: "gray-shingle", src: IMAGES.gallery[1], alt: "Gray asphalt shingle close-up", span: "col-span-6 row-span-1" },
  { id: "solar-roof", src: IMAGES.gallery[2], alt: "Dark roof installation with solar panels", span: "col-span-3 row-span-1" },
];

export default function Gallery({ t }) {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-20 md:py-32 bg-brand-light">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div className="max-w-2xl">
            <span className="section-tag" data-testid="gallery-tag">{t.gallery.tag}</span>
            <h2
              data-testid="gallery-title"
              className="font-display font-black text-brand-primary text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-5 leading-[1.05]"
            >
              {t.gallery.title}
            </h2>
          </div>
          <p className="text-base text-brand-muted max-w-md md:text-right leading-relaxed">{t.gallery.subtitle}</p>
        </div>

        <div className="grid grid-cols-12 grid-rows-2 gap-3 md:gap-4 h-[420px] md:h-[560px]">
          {TILES.map((tile, i) => (
            <div key={tile.id} data-testid={`gallery-tile-${i}`} className={`${tile.span} overflow-hidden bg-brand-secondary`}>
              <img src={tile.src} alt={tile.alt} className="w-full h-full object-cover gallery-img" loading="lazy" />
            </div>
          ))}
          <div
            data-testid="gallery-tile-3"
            className="col-span-3 row-span-1 overflow-hidden bg-brand-primary text-white p-5 md:p-6 flex flex-col justify-between"
          >
            <div className="font-display text-xs font-bold tracking-widest uppercase text-brand-accent">
              {t.gallery.qualityTag}
            </div>
            <div className="font-display font-black text-2xl md:text-3xl leading-tight tracking-tighter">
              {t.gallery.qualityTitle}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
